import { DraftPresentationType } from "../CandyApiClient/Types/Presentations/DraftPresentationType";

export enum PrinterResultTypes {
    Unknown,
    Pdf,
    Excel,
    Html,
    Xml,
}

export enum RsvInfoTypes {
    PersonsSection321 = 2,
    PersonsSection321WithContracts = 3,
    PersonsSection322 = 4,
    PersonsRevise = 5,
}

export enum NdflInfoTypes {
    PersonsReport = 0,
    Registry = 1,
    SummaryTable = 2,
    Revice = 3,
}

export enum EfsInfoTypes {
    PersonsReport = 0,
}

export enum FSPrinterTaskResultStatus {
    Executing = "Executing",
    Failed = "Failed",
    Success = "Success",
}

//Пока докинул что надо для печати РСВ, дальше можно расширять по мере надобности
export interface PrinterOptions {
    resultType?: PrinterResultTypes;
    krecPdfPrint?: boolean; // печать через K.Recognition (истребования)
    fuf?: { driveUri: string };
    rsvInfo?: { type: RsvInfoTypes };
    ndflInfo?: { type: NdflInfoTypes };
    efsInfo?: { type: EfsInfoTypes };
    senderApp?: "candy-front";
    presentation?: DraftPresentationType.innerFuf | DraftPresentationType.fuf;
    clientInfo?: unknown;
}

export interface RSVPrinterOptions {
    resultType?: PrinterResultTypes;
    type: RsvInfoTypes;
    presentation?: DraftPresentationType.innerFuf | DraftPresentationType.fuf;
    innerFuf?: { driveUri: string };
}

export interface PrintByRulesOptions {
    rules: string[];
    options: Pick<PrinterOptions, "rsvInfo" | "ndflInfo" | "efsInfo">;
}

export interface PrinterRequestOptions {
    timeout?: number;
    pullingDelay?: number;
    factor?: number;
}

export interface IFSPrinterClient {
    print(options: PrinterOptions, requestOptions?: PrinterRequestOptions): Promise<void>;
    printByRules(options: PrintByRulesOptions): Promise<void>;
    printRSV(rsvOptions: RSVPrinterOptions, requestOptions?: PrinterRequestOptions): Promise<void>;
}

export interface FSPrinterTaskResult extends FSPrinterTaskStatus {
    resultUri?: string;
    resultMimeType?: string;
    isResultPartial?: boolean;
    errorInfo?: {
        errorCode: string;
        httpStatusCode: number;
        systemMessage: string;
        userMessage: string;
    };
}

export interface FSPrinterTaskStatus {
    taskId: string;
    status: FSPrinterTaskResultStatus;
    progress: number;
}
